module.exports = __webpack_public_path__ + "img/pub-messenger.56bfb1b0.svg";